import {Component} from '@angular/core';
import { IWizItemRenderer, WizBaseCollector, WizDatasource } from '@wizeoo/akm-component-lib';

/**
 * rendu d'un avec une checkbox, une image et un label
 */
@Component({
  selector: 'check-flag-label-renderer',
  templateUrl: './check-flag-label.renderer.html'
})
export class CheckFlagLabelRenderer implements IWizItemRenderer<null, any> {

  _data: any;

  public set data(value: any) {
    this._data = value;
  }
  public get data(): any {
    return this._data;
  }
  owner: WizBaseCollector;

  /**
   * Synchronisation de la sélection de la ligne et celle de la checkbox
   * @returns boolean true si la ligne est sélectionnée, false sinon
   */
  public isSelected(): boolean {
    const datas: WizDatasource<any> = this.owner.wizDataProvider;
    if (datas && datas.selectedItems && datas.selectedItems.indexOf(this.data) > -1) {
      return true;
    }
    return false;
  }

}

